import {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class LayerData
  * A generic base class for all layer data components.
  */
export default class LayerData extends Component {
  /** @constructor
    * Constructs a new isntance of LayerData,
    * assigning the layer props to state and
    * binding event handlers.
    */
  constructor(props) {
    super(props);
    this.state = props.layer;
    this.handleChange = this.handleChange.bind(this);
    this.handleIntChange = this.handleIntChange.bind(this);
    this.handleFloatChange = this.handleFloatChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @method componentWillRecieveNewProps
    * Responds to changes in the layer props.
    */
  componentWillRecieveNewProps(newProps) {
    this.setState({...newProps.layer});
  }
  /** @function handleChange
    * Changes the state of the component based on
    * user input.
    * @param {InputEvent} - the event triggering the change.
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleIntChange
    * Changes the state of the component based on
    * user input.
    * @param {InputEvent} - the event triggering the change.
    */
  handleIntChange(event) {
    const target = event.target;
    const value = parseInt(target.value, 10);
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleIntChange
    * Changes the state of the component based on
    * user input.
    * @param {InputEvent} - the event triggering the change.
    */
  handleFloatChange(event) {
    const target = event.target;
    const value = parseFloat(target.value);
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleImageUpload
    * Updates the state of the component with a
    * new image and saves it to the database
    * @param {string} name - the field to update
    * @param {url} url - the new image url
    */
  handleImageUpload(name, url) {
    this.setState({[name]: url});
    this.handleBlur();
  }
  /** @function handleBlur
    * Saves the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/layer-data.js